"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createAdapters", {
  enumerable: true,
  get: function get() {
    return _createAdapters.default;
  }
});

var _createAdapters = _interopRequireDefault(require("./createAdapters"));
/* global process */


if (typeof HTMLDocument !== 'undefined' && typeof document !== 'undefined' && document instanceof HTMLDocument) {
  var meta = document.createElement('meta');
  meta.setAttribute('name', 'botframework-directlinespeech:version');
  meta.setAttribute('content', "4.8.0");
  document.head.appendChild(meta);
}